import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import './Success.css';
import posthog from 'posthog-js';

const SuccessV2: React.FC = () => {
  useEffect(() => {
    const gtag = (window as unknown as { gtag?: (...args: unknown[]) => void })
      .gtag;
    if (typeof window !== 'undefined' && gtag) {
      gtag('event', 'conversion_event_purchase', {});
    }
    posthog.capture('payment_successful', {
      source: 'v2_success',
    });
  }, []);

  return (
    <motion.div
      className="success-page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="success-container">
        <header className="success-intro">
          <motion.div
            className="success-icon"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.05, duration: 0.45, ease: 'easeOut' }}
            aria-hidden
          >
            <svg
              width="72"
              height="72"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                fill="#10B981"
                stroke="#10B981"
                strokeWidth="2"
              />
              <path
                d="M8 12l2 2 4-4"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </motion.div>
          <motion.h1
            className="success-title"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.12, duration: 0.45 }}
          >
            You&apos;re all set!
          </motion.h1>
          <motion.p
            className="success-message"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.45 }}
          >
            Your purchase was successful. You can return to Premiere Pro and
            continue using Substyle.
          </motion.p>
        </header>
      </div>
    </motion.div>
  );
};

export default SuccessV2;
